<template>
    <div class="input-group-sm">
        <v-select v-model="inspection" ref="empSelect" label="EmployeeId" :filterable="false" @search="onSearch" @input="onChange" :options="options" :placeholder="`Search ${placeholder}`" :class="{'filter-select': forFilters, 'is-invalid': hasError}">
            <template slot="no-options">
                Type to Search Inspections...
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    {{ option.InspectionId }} - {{ option.JobsiteNumber }} - {{ option.JobsiteName }} on {{ option.InspectionDate }}
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                    {{ option.InspectionId }} - {{ option.JobsiteNumber }} - {{ option.JobsiteName }} on {{ option.InspectionDate }}
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
    export default {
        props: {
            selectedValues: {
                type: Object,
                default: null
            },

            forFilters: {
                type: Boolean,
                default: false,
            },

            excludeId: {
                type: Number,
            },

            placeholder: {
                type: String,
                default: 'Inspections',
            },

            hasError: {
                type: Boolean,
                default: false,
            },

            filters: {
                type: Object,
                default: null
            },
        },

        data: function() {
            return {
                options: [],
                inspection: null,
            }
        },

        watch: {
            //Watcher for errors
            hasError(newValue, oldValue){
                //Set it
                this.hasError = newValue;
            },

            selectedValues(newValue, oldValue){
                if(newValue != null && Object.keys(newValue).length > 0 && !this.inspection)
                {
                    this.options.push(newValue);
                    this.inspection = newValue;
                }
            }
        },

        methods: {
            //Search
            onSearch: function(searchTerm, searchLoading){
                //Done loading
                searchLoading(true);

                //Send it
                this.$http.get('/inspections/search', {term: searchTerm, excludeId: this.excludeId, filters: this.filters})
                    .then(res => {
                        //Set the data
                        this.options = res.data;

                        //Done loading
                        searchLoading(false);
                    });
            },

            setSelectedValues(inspection){
                //Set the value
                this.inspection = inspection;
            },

            //Emit the event
            onChange: function(inspection) {
                //Make sure we're not loading
                if (!this.loading)
                {
                    //Send it
                    this.$emit('vselected', inspection);
                }
            },

            clearInput(){
                //Set to null
                this.inspection = null;
                this.options = [];
                this.$refs.empSelect.clearSelection();
            }
        },

        mounted() {
            if(this.selectedValues != null && Object.keys(this.selectedValues).length > 0)
            {
                this.options.push(this.selectedValues);
                this.inspection = this.selectedValues;
            }
        }
    }
</script>

<style scoped>
    .filter-select {
        background-color: #fff;
    }

    .filter-select.open >>> .selected-tag {
        margin-top: 3px;
    }

    .filter-select >>> .dropdown-toggle {
        border: 1px solid #c6c6c6;
        max-height: 31px;
        margin-top: -1px;
        padding: 1px 0 3px 0;
    }

    .filter-select >>> .selected-tag {
        margin: 3px 0 0 0;
        padding-left: 5px;
        white-space: nowrap;
        overflow: hidden;
        width: 200px;
    }

    .filter-select >>> .vs__actions button {
        margin-top: 3px;
    }

    .vs__search::placeholder,
    .vs__dropdown-toggle,
    .vs__dropdown-menu {
      background: #dfe5fb;
      border: none;
      color: #394066;
      text-transform: lowercase;
      font-variant: small-caps;
    }

    .vs__clear,
    .vs__open-indicator {
      fill: #394066;
    }
</style>